import HeaderComponent from "./headerComponent";
export default function ShiftDetailsComponent() {
  return (
    <div>
      <HeaderComponent />
    </div>
  );
}
